import { FC, memo } from 'react';
import { Typography } from 'ui/Typography';
import { Box } from 'ui/Box';

export interface ISteps {
  steps: number;
  currentStep: number;
}
export const Steps: FC<ISteps> = memo(({ steps, currentStep }) => (
  <Box className="flex flex-col gap-2">
    <Box className="flex gap-[4px]">
      {Array.from({ length: steps }).map((_, index) => (
        <Box
          key={index}
          className={`h-[0.125rem] flex-1 rounded-3xl bg-blue ${
            currentStep >= index ? '' : 'opacity-20'
          }`}
        />
      ))}
    </Box>
    <Typography className="text-center text-blue md:text-left">
      Step {currentStep + 1}/{steps}
    </Typography>
  </Box>
));
